@if (eventStoreService.event()) {
  <app-event-header></app-event-header>
}

@if (
  eventStoreService.event() &&
  ((eventStoreService.event()!.sessions &&
    eventStoreService.event()!.sessions.length > 1) ||
    (eventStoreService.event()!.products &&
      eventStoreService.event()!.products.length > 1))
) {
  <form
    #shoutoutsFilterForm
    class="shoutouts-filters"
    [formGroup]="filterForm"
    (submit)="filterShoutouts()"
  >
    @if (
      eventStoreService.event() &&
      eventStoreService.event()!.sessions &&
      eventStoreService.event()!.sessions.length > 1
    ) {
      <mat-form-field class="shoutouts-filters__input" appearance="outline">
        <mat-label for="sessionId">All sessions</mat-label>
        <mat-select
          formControlName="sessionId"
          (selectionChange)="filterShoutouts()"
        >
          <mat-option [value]="null">All sessions</mat-option>
          @for (
            session of eventStoreService.event()!.sessions;
            track session.id
          ) {
            <mat-option [value]="session.id">{{ session.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (
      eventStoreService.event() &&
      eventStoreService.event()!.products &&
      eventStoreService.event()!.products.length > 1
    ) {
      <mat-form-field class="shoutouts-filters__input" appearance="outline">
        <mat-label for="productId">All products</mat-label>
        <mat-select
          formControlName="productId"
          (selectionChange)="filterShoutouts()"
        >
          <mat-option [value]="null">All products</mat-option>
          @for (
            product of eventStoreService.event()!.products;
            track product.id
          ) {
            <mat-option [value]="product.id">{{ product.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <button
      mat-flat-button
      (click)="clearFilter()"
      color="secondary"
      class="shoutouts-filters__button"
    >
      <mat-icon
        aria-hidden="false"
        aria-label="Clear filter Shoutouts"
        matTooltip="Clear filter Shoutouts"
        fontIcon="clear_all"
      ></mat-icon
      >&nbsp;Clear
    </button>
  </form>
}

<nav mat-tab-nav-bar [backgroundColor]="" [tabPanel]="tabPanel">
  <a
    mat-tab-link
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive"
    [routerLink]="['shoutouts', 'announce']"
    [queryParams]="{ sessionId: sessionId() }"
    ><span
      matBadge="{{
        shoutoutsToAnnounceCount() > 9 ? '9+' : shoutoutsToAnnounceCount()
      }}"
      [matBadgeOverlap]="false"
      [ngClass]="{ 'badge-neutral': shoutoutsToAnnounceCount() === 0 }"
      >Announce</span
    ></a
  >
  <a
    mat-tab-link
    routerLinkActive
    #rla3="routerLinkActive"
    [active]="rla3.isActive"
    [routerLink]="['shoutouts', 'completed']"
    [queryParams]="{ sessionId: sessionId() }"
    >Completed</a
  >
  <a
    mat-tab-link
    routerLinkActive
    #rla4="routerLinkActive"
    [active]="rla4.isActive"
    [routerLink]="['shoutouts', 'rejected']"
    [queryParams]="{ sessionId: sessionId() }"
    >Rejected</a
  >
</nav>

<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

<router-outlet></router-outlet>
